<template>
  <v-card>
    <v-container class="py-0" fluid>
      <v-row align-content="space-around">
        <v-col cols="12" sm="3">
          <v-card-title class="pa-0">
            <div>
              <div class="headline">Intake Statistics</div>
            </div>
          </v-card-title>
        </v-col>
      </v-row>
      <v-row align="center" class="mb-2">
        <v-col cols="12" sm="6">
          <v-btn-toggle v-model="retainedBasis" mandatory dense>
            <v-btn value="cash">Cash Retained</v-btn>
            <v-btn value="accrual">Accrual Retained</v-btn>
          </v-btn-toggle>
        </v-col>
      </v-row>
      <org-home-intake-stats-pacing :retained-basis="retainedBasis" />
      <v-row align-content="space-around">
        <v-col cols="12" sm="12">
          <org-retained-by-day :retained-basis="retainedBasis" />
        </v-col>
      </v-row>
      <v-row align-content="space-around">
        <v-col cols="12" sm="12">
          <org-leads-stats-by-day :retained-basis="retainedBasis" />
        </v-col>
      </v-row>
      <v-row align-content="space-around">
        <v-col cols="12" sm="12">
          <org-leads-stats-by-day-by-source :retained-basis="retainedBasis" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <intake-referrals :retained-basis="retainedBasis" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-card>
            <v-toolbar flat dense>
              <span class="text-subtitle-1">Leads by Type</span>
            </v-toolbar>
            <org-leads-stats-by-type />
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card>
            <v-toolbar flat dense>
              <span class="text-subtitle-1">Wanted by Type</span>
            </v-toolbar>
            <org-wanted-stats-by-type />
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card>
            <v-toolbar flat dense>
              <span class="text-subtitle-1">Signed by Type</span>
            </v-toolbar>
            <org-signed-stats-by-type />
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <org-intake-agent-stats />
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import OrgRetainedByDay from "../charts/OrgRetainedByDay";
import OrgLeadsStatsByDay from "../charts/OrgLeadsStatsByDay";
import OrgLeadsStatsByDayBySource from "../charts/OrgLeadsStatsByDayBySource";
import OrgLeadsStatsByType from "../charts/OrgLeadsStatsByType";
import OrgWantedStatsByType from "../charts/OrgWantedStatsByType";
import OrgSignedStatsByType from "../charts/OrgSignedStatsByType";
import OrgIntakeAgentStats from "../charts/OrgIntakeAgentStats";
import OrgHomeIntakeStatsPacing from "./OrgHomeIntakeStatsPacing";
import IntakeReferrals from "../charts/IntakeReferrals";

export default {
  data() {
    return {
      retainedBasis: "cash"
    };
  },
  components: {
    IntakeReferrals,
    OrgRetainedByDay,
    OrgLeadsStatsByDay,
    OrgLeadsStatsByDayBySource,
    OrgLeadsStatsByType,
    OrgWantedStatsByType,
    OrgSignedStatsByType,
    OrgHomeIntakeStatsPacing,
    OrgIntakeAgentStats
  }
};
</script>

<style scoped></style>
